import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import ContractsActions, { ContractsRedux, ContractsTypes } from '../Redux/ContractsRedux'

const contractsCRUDObservable = createCRUDObservable({
  mainRedux: ContractsRedux,
  reduxPath: 'contracts',
})

const getContractsEpic = (action$, store, { Api }) => (
  action$.ofType(ContractsTypes.getContractsRequest)
    .mergeMap(({ parentId }) => (
      Api.contracts.getContracts(parentId)
        .then(response => response.data.data)
        .then(result => ContractsActions.getContractsSuccess(result))
        .catch(err => ContractsActions.getContractsError(err))
    ))
)
const getContractsByCompanyIdEpic = (action$, store, { Api }) => (
  action$.ofType(ContractsTypes.getContractsByCompanyIdRequest)
    .mergeMap(({ companyId }) => (
      Api.contracts.getContractsByCompanyId(companyId)
        .then(response => response.data.data)
        .then(result => ContractsActions.getContractsByCompanyIdSuccess(result))
        .catch(err => ContractsActions.getContractsByCompanyIdError(err))
    ))
)
export const contractsObservers = Object.assign({}, contractsCRUDObservable.observers,
  { getContractsEpic })


export const contractsEpic = combineEpics(
  contractsCRUDObservable.epic,
  getContractsEpic,
  getContractsByCompanyIdEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ContractsObservable.js